import * as R from 'ramda';
import { formatDateForExport } from 'utils/helpers/format';

const minWidth = 150;

const InventoryDetailsColumns = [
  {
    cellClassName: 'css-heap-redact',
    field: 'productShortName',
    headerName: 'Product',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'productIdName',
    headerName: 'Product ID',
    minWidth,
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'volume',
    headerName: 'Volume (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'locationShortName',
    headerName: 'Location',
    minWidth,
  },
  {
    field: 'locationIdName',
    headerName: 'Location ID',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'originShortName',
    headerName: 'Origin',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'originIdName',
    headerName: 'Origin ID',
    minWidth,
  },
  {
    field: 'ticketDtm',
    headerName: 'Ticket Date (CST)',
    minWidth,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'shipmentId',
    headerName: 'Shipment Request ID',
    minWidth,
    renderCell: ({ row }) => (R.prop('shipmentId', row) ? R.prop('shipmentId', row) : null), // remove commas from numbers
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerShortName',
    headerName: 'Inventory Owner',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerIdName',
    headerName: 'Inventory Owner ID',
    minWidth,
  },
  {
    field: 'rvp',
    headerName: 'RVP',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'shipperShortName',
    headerName: 'Shipper',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'shipperIdName',
    headerName: 'Shipper ID',
    minWidth,
  },
  {
    field: 'tariffDate',
    headerName: 'Tariff Date',
    minWidth,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'releaseDate',
    headerName: 'Release Date',
    minWidth,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'reserved',
    headerName: 'Reserved',
    minWidth,
  },
  {
    field: 'transitTimeRelease',
    headerName: 'Transit Time Release',
    minWidth,
  },
  {
    field: 'reconsControlLocationId',
    headerName: 'Recons Control Location ID',
    minWidth,
  },
  {
    field: 'partialReleaseDate',
    headerName: 'Partial Rel Date',
    minWidth,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'creatingObject',
    headerName: 'Creating Object',
    minWidth,
  },
  {
    field: 'objectType',
    headerName: 'Object Type',
    minWidth,
  },
  {
    field: 'objectTypeDesc',
    headerName: 'Object Type Description',
    minWidth,
  },
  {
    field: 'ton',
    headerName: 'Ton',
    minWidth,
  },
];

export default InventoryDetailsColumns;
